import React, { useEffect, useState } from "react";
import "./FormFieldsStyle.css";
import { Select } from "antd";

const Dropdown = (props) => {
  const dataList = props.item && props.item.text_data;
  const selection = props?.item?.text_data?.disableSelection === true;
  const defaultValue = props?.item?.text_data?.defaultValue;
  const [open, setOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState(defaultValue || null);
  const [forceUpdate, setForceUpdate] = useState(0); // Force re-render

  useEffect(() => {
   
  
    if (defaultValue) {
  
  
      setSelectedValue(defaultValue);
  
      setTimeout(() => {

        props?.setErrors((prevErrors) => {
          const updatedErrors = { ...prevErrors };
          updatedErrors[props?.index] = { key1: defaultValue, displayName: defaultValue };
    
          console.log("🔄 Updated Errors inside useEffect:", updatedErrors);
          return updatedErrors;
        });
        
      }, 1000);
     
  
      setTimeout(() => {
        console.log("⏳ Delayed Check (ensures state commit):", props.errors);
      }, 100);
    }
  }, [defaultValue, props.index]);
  

  const handleChange = (value, option) => {
   if(selection) return
    if (value) {
      props?.inputValue?.current?.removeAttribute("disabled");
    } else {
      props?.inputValue?.current?.setAttribute("disabled", true);
    }

    props?.setErrors((prevErrors) => {
      const updatedErrors = {
        ...prevErrors,
        [props?.index]: { key1: value, displayName: value},
      };
      console.log("Updated Errors after user selection:", updatedErrors);
      return updatedErrors;
    });

    localStorage.setItem(
      "inputValue",
      JSON.stringify({ key1: value, displayName: option?.children })
    );

    setSelectedValue(value);
  };

  const handleOpenChange = (open) => {
    setOpen(open);
  };

  const Options = dataList?.data?.map((item) => (
    <Select.Option key={item.value} value={item.value}>
       <span dangerouslySetInnerHTML={{ __html: item?.name }} />
    </Select.Option>
  ));

  return (
    <div
      className="form-group action-tab"
      style={{ width: "90%", margin: "14px 14px 14px 4px" }}
    >
      <Select
        placeholder={selection ? "Check list" : "Please select"}
        value={selectedValue}
        onChange={handleChange}
        open={open}
        onDropdownVisibleChange={handleOpenChange}
        style={{ width: "100%" }}
        // dropdownClassName="custom-select"
        popupClassName="custom-select"
        className={`custom-select error-${props?.index}`}
      >
        {Options}
      </Select>
      <span className="validate">&nbsp;</span>
    </div>
  );
};

export default Dropdown;
